<template>
  <div>
    <v-card-title class="d-flex justify-center">
      <v-spacer />
      گزارش سفارش شماره :
      <span class="blue--text">
        {{
          reportData && reportData.tradeNumber
            ? ' ' + reportData.tradeNumber + ' '
            : ''
        }}
      </span>
      <v-spacer />

      نام کسب و کار :
      <span class="blue--text">
        {{
          reportData && reportData.merchantName
            ? ' ' + reportData.merchantName + ' '
            : ''
        }}
      </span>
      <v-spacer />

      به تاریخ :
      <span class="red--text">
        {{
          reportData && reportData.createdTimeUtc
            ? ' ' + jalaliDate(reportData.createdTimeUtc) + ' '
            : ''
        }}
      </span>
      <v-spacer />
    </v-card-title>
    <v-sheet outlined color="blue">
      <v-card outlined elevation="0" class="pa-5">
        <v-row>
          <v-col cols="6" sm="4" md="3">
            <label>موضوع سفارش:</label>
            <strong>
              {{
                reportData && reportData.request
                  ? tradeRequestDisplayName(reportData.request)
                  : ''
              }}
            </strong>
          </v-col>
          <v-col cols="6" sm="4" md="3">
            <label>دسته سفارش:</label>
            <strong>
              {{
                reportData && reportData.category
                  ? tradeCategoryDisplayName(reportData.category)
                  : ''
              }}
            </strong>
          </v-col>
          <v-col
            cols="6"
            sm="4"
            md="3"
            v-if="reportData && reportData.request != 'ContractorRecognition'"
          >
            <label> روش پرداخت:</label>
            <strong
              >{{
                reportData && reportData.paymentMethod
                  ? paymentMethodDisplayName(reportData.paymentMethod)
                  : ''
              }}
            </strong>
          </v-col>
          <v-col cols="6" sm="4" md="3" v-else>
            <label> نوع تضمین:</label>
            <strong>
              {{
                reportData && reportData.guarantee
                  ? guaranteeMethodDisplayName(reportData.guarantee)
                  : ''
              }}
            </strong>
          </v-col>
          <v-col cols="6" sm="4" md="3">
            <label>
              مهلت شرکت در
              {{
                reportData && reportData.request
                  ? tradeRequestDisplayName(reportData.request)
                  : ''
              }}:
            </label>
            <strong
              >{{
                reportData && reportData.bidExpirationTimeInDays
                  ? reportData.bidExpirationTimeInDays
                  : ''
              }}
              روز ({{
                reportData &&
                reportData.bidExpirationTimeInDaysFromNow &&
                reportData.bidExpirationTimeInDaysFromNow != 0
                  ? reportData.bidExpirationTimeInDaysFromNow + 'روز باقی مانده'
                  : 'منقضی شده'
              }})
            </strong>
          </v-col>
          <v-col
            cols="6"
            sm="4"
            md="3"
            v-if="reportData && reportData.request == 'ContractorRecognition'"
          >
            <label> مدت زمان اجرای طرح : </label>
            <strong
              >{{
                reportData && reportData.runningDuration
                  ? reportData.runningDuration
                  : 0
              }}
              ماه
            </strong>
          </v-col>
          <v-col cols="6" sm="4" md="3">
            <label> نام کسب و کار: </label>
            <strong>{{
              reportData && reportData.merchantName
                ? reportData.merchantName
                : ''
            }}</strong>
          </v-col>

          <v-col cols="6" sm="4" md="3">
            <label> تاریخ ایجاد:</label>
            <strong>{{
              reportData && reportData.createdTimeUtc
                ? jalaliDate(reportData.createdTimeUtc)
                : ''
            }}</strong>
          </v-col>
          <v-col cols="6" sm="4" md="3">
            <label> نام مسئول:</label>
            <strong>{{
              reportData && reportData.ownerName ? reportData.ownerName : ''
            }}</strong>
          </v-col>

          <v-col cols="12" v-if="reportData && reportData.limitation">
            <label>محدودیت مکانی : </label>
            <strong>
              {{
                reportData && reportData.limitation == null
                  ? 'ندارد'
                  : reportData.limitation == 'State'
                  ? 'استانی'
                  : reportData.limitation == 'City'
                  ? 'شهری'
                  : ''
              }}
            </strong>
            <div v-if="reportData.limitation == 'State'">
              <label> لیست استان ها : </label>
              <strong v-for="state in stateName" :key="state">
                {{ state }} ،
              </strong>
            </div>
            <div v-else-if="reportData.limitation == 'City'">
              <v-col cols="12">
                <label> لیست استان ها : </label>
                <strong v-for="state in stateName" :key="state">
                  {{ state }}،
                </strong>
              </v-col>
              <v-col cols="12">
                <label> لیست شهرها : </label>
                <strong v-for="city in cityName" :key="city">
                  {{ city }} ،
                </strong>
              </v-col>
            </div>
          </v-col>
          <v-col cols="12">
            <label
              >{{
                reportData && reportData.request != 'ContractorRecognition'
                  ? 'توضیحات سفارش '
                  : 'عنوان'
              }}:</label
            >
            <strong
              >{{
                reportData.content && reportData.content.length
                  ? reportData.content
                  : 'وارد نشده'
              }}
            </strong>
          </v-col>
        </v-row>
      </v-card>
    </v-sheet>
    <v-sheet outlined color="blue" class="mt-5">
      <v-card outlined elevation="0" class="pa-5">
        <v-row>
          <v-col cols="12">
            <label> شرح پروژه/ طرح :</label>
            <strong
              >{{
                reportData.orderDescription &&
                reportData.orderDescription.length
                  ? reportData.orderDescription
                  : 'وارد نشده'
              }}
            </strong>
          </v-col>
        </v-row>
      </v-card>
    </v-sheet>
    <v-sheet
      class="mt-5"
      outlined
      v-for="(item, ind) in reportData.items"
      :key="ind"
      color="blue"
    >
      <v-card outlined elevation="0" class="pa-5">
        <v-row>
          <!-- <div v-if="reportData.request != 'ContractorRecognition'"> -->
          <v-col
            cols="6"
            sm="4"
            md="3"
            v-if="reportData && reportData.request != 'ContractorRecognition'"
          >
            <label> موضوع :</label>
            <strong>{{ item && item.title ? item.title : '' }} </strong>
          </v-col>

          <v-col
            cols="6"
            sm="4"
            md="3"
            v-if="reportData && reportData.request != 'ContractorRecognition'"
          >
            <label> مقدار :</label>
            <strong>{{ item && item.quantity ? item.quantity : '' }} </strong>
          </v-col>
          <v-col
            cols="6"
            sm="4"
            md="3"
            v-if="reportData && reportData.request != 'ContractorRecognition'"
          >
            <label> تاریخ نیاز :</label>
            <strong
              >{{
                item && item.requireDateUtc
                  ? jalaliDate(item.requireDateUtc)
                  : ''
              }}
            </strong>
          </v-col>

          <v-col
            cols="6"
            sm="4"
            md="3"
            v-if="reportData && reportData.request != 'ContractorRecognition'"
          >
            <label> نحوه تامین مواد :</label>
            <strong
              >{{
                item && item.materialSupplyType
                  ? materialSupplyTypeDisplayName(item.materialSupplyType)
                  : ''
              }}
            </strong>
          </v-col>
          <v-col
            cols="6"
            sm="4"
            md="3"
            v-if="reportData && reportData.request != 'ContractorRecognition'"
          >
            <label> جنس مواد اولیه :</label>
            <strong
              >{{
                item && item.rawMaterialName
                  ? item.rawMaterialName
                  : 'وارد نشده'
              }}
            </strong>
          </v-col>
          <v-col
            cols="6"
            sm="4"
            md="3"
            v-if="reportData && reportData.request != 'ContractorRecognition'"
          >
            <label> محل تحویل:</label>
            <strong
              >{{
                item && item.deliveryLocation
                  ? DeliveryLocationDisplayName(item.deliveryLocation)
                  : ''
              }}
            </strong>
          </v-col>
          <v-col
            cols="6"
            sm="4"
            md="3"
            v-if="reportData && reportData.request != 'ContractorRecognition'"
          >
            واحد شمارش:
            <strong>
              {{
                item && item.measurementUnitTitle
                  ? item.measurementUnitTitle
                  : ''
              }}</strong
            >
          </v-col>

          <v-col
            cols="6"
            sm="4"
            md="3"
            v-if="reportData && reportData.request != 'ContractorRecognition'"
          >
            <label> روند تحویل دهی :</label>
            <strong>
              {{ item.deliveryType == 'Entirely' ? 'یکجا' : 'ادواری' }}
            </strong>
          </v-col>
          <v-col
            cols="6"
            sm="4"
            md="3"
            v-if="reportData && reportData.request != 'ContractorRecognition'"
          >
          </v-col>
          <v-col
            cols="12"
            v-if="reportData && reportData.request != 'ContractorRecognition'"
          >
            <div class="mb-1">
              <strong class="blue--text"> جدول تحویل دهی: </strong>
            </div>
            <v-card class="mx-2">
              <base-table
                :headers="deliveryItemHeader"
                :items="item.deliveryItems"
                hide-default-footer
              >
                <template v-slot:[`item.deliveryDateUtc`]="{ item }">
                  {{ jalaliDate(item.deliveryDateUtc) }}
                </template>
              </base-table>
            </v-card>
          </v-col>
          <!-- </div> -->
          <!-- ------------------- -->
          <v-col cols="12">
            <v-col cols="12">
              <strong class="blue--text">مدارک مورد نیاز پاسخ </strong>
            </v-col>
            <v-sheet
              outlined
              v-if="item.responseDocuments && item.responseDocuments.length"
            >
              <v-data-table
                :items="item.responseDocuments"
                disable-pagination
                :headers="responseDocumentHeader"
                hide-default-footer
              >
                <template v-slot:[`item.isOptional`]="{ item }">
                  {{ item.isOptional ? 'اختیاری' : 'اجباری' }}
                </template>
              </v-data-table>
            </v-sheet>
          </v-col>
          <v-col cols="12">
            <v-sheet outlined class="pa-1 pa-6 mt-5">
              <v-col cols="12">
                <strong class="blue--text">فایل اطلاعات پیوست </strong>
              </v-col>
              <div v-if="item.documents && item.documents.length">
                <v-row>
                  <v-col
                    cols="6"
                    md="4"
                    v-for="(x, i) in item.documents"
                    :key="i"
                  >
                    <v-card>
                      <v-card-text>
                        <v-col cols="12">
                          <v-img
                            v-if="x.fileId && x.fileId.thumbnailFileUrl"
                            :src="x.fileId.thumbnailFileUrl"
                            width="100%"
                          />
                        </v-col>
                        <v-col cols="12">
                          <label> نوع فایل:</label>
                          <strong>{{ x.documentTypeTitle }}</strong>
                        </v-col>
                        <v-col cols="12">
                          <label> توضیحات:</label>
                          <strong>{{
                            x.description ? x.description : 'وارد نشده'
                          }}</strong>
                        </v-col>
                        <v-col cols="12">
                          <a
                            target="_blank"
                            :href="
                              x.fileId && x.fileId.fileUrl
                                ? x.fileId.fileUrl
                                : ''
                            "
                            >{{
                              x.fileId && x.fileId.fileUrl ? 'دانلود' : ''
                            }}</a
                          >
                        </v-col>
                      </v-card-text>
                    </v-card>
                  </v-col>
                </v-row>
              </div>
              <strong v-else>فاقد اسناد پیوست</strong>
            </v-sheet>
          </v-col>
          <v-col cols="12">
            <v-sheet
              outlined
              class="pa-1 pa-6 mt-5"
              v-if="item.techInfos && item.techInfos.length"
            >
              <v-col cols="12">
                <strong
                  class="blue--text"
                  v-if="
                    item.techInfos.length &&
                    item.techInfos[0].tradeRequestItemPropertyValues &&
                    item.techInfos[0].tradeRequestItemPropertyValues.length == 0
                  "
                >
                  نوع فرآیند
                </strong>
                <strong
                  class="blue--text"
                  v-else-if="
                    item.techInfos.length &&
                    item.techInfos[0].tradeRequestItemPropertyValues &&
                    item.techInfos[0].tradeRequestItemPropertyValues.length > 0
                  "
                >
                  مشخصات
                  {{ item.techInfos[0].productCategoryName }}
                </strong>
              </v-col>
              <v-row class="mt-3">
                <v-col
                  cols="12"
                  v-if="
                    item.techInfos.length &&
                    item.techInfos[0].tradeRequestItemPropertyValues &&
                    item.techInfos[0].tradeRequestItemPropertyValues.length == 0
                  "
                >
                  <TradeRequestInformationTable
                    :items="item.techInfos"
                    :fields="tradeRequestInformationFields"
                  />
                </v-col>

                <v-card
                  width="100%"
                  class="pa-5"
                  v-else-if="
                    item.techInfos.length &&
                    item.techInfos[0].tradeRequestItemPropertyValues &&
                    item.techInfos[0].tradeRequestItemPropertyValues.length > 0
                  "
                >
                  <v-row>
                    <v-col
                      cols="12"
                      sm="6"
                      v-for="(property, index) in item.techInfos[0]
                        .tradeRequestItemPropertyValues"
                      :key="index"
                    >
                      <v-row>
                        <v-col cols="12" sm="4">
                          <label
                            >{{ property.categoryPropertyTitle }} :
                          </label></v-col
                        >

                        <v-col cols="12" sm="8">
                          <strong
                            v-if="property.propertyType == 'MultiSelectList'"
                          >
                            <label
                              v-for="(prop, index) in property.value.split('|')"
                              :key="index"
                            >
                              {{ prop.replaceAll('null', '') }}
                              <label
                                v-if="
                                  index <
                                    property.value.split('|').length - 1 && prop
                                "
                              >
                                -
                              </label>
                            </label>
                          </strong>
                          <strong
                            v-else-if="property.propertyType == 'Logical'"
                          >
                            {{ property.value == true ? 'بله' : 'خیر' }}
                          </strong>
                          <strong v-else
                            >{{
                              property.maxValue
                                ? `از ${property.value} تا ${property.maxValue}`
                                : property.value
                            }}
                            {{ property.measurementUnitDisplayText }}</strong
                          >
                        </v-col>
                      </v-row>
                    </v-col>
                  </v-row>
                </v-card>
              </v-row>
            </v-sheet>
          </v-col>
          <!-- -------------------- -->
          <v-col
            cols="12"
            v-if="reportData && reportData.request != 'ContractorRecognition'"
          >
            <label> توضیحات قلم :</label>
            <strong
              >{{ item.description ? item.description : 'وارد نشده' }}
            </strong>
          </v-col>
        </v-row>
      </v-card>
    </v-sheet>
    <div v-if="!succeedPayment">
      <div
        v-if="
          (membershipAndPrice && !membershipAndPrice.hasMembership) ||
          (membershipAndPrice &&
            membershipAndPrice.hasMembership &&
            membershipAndPrice.membershipDetails &&
            !membershipAndPrice.membershipDetails.isAvailable)
        "
        class="m-5"
      >
        <v-alert
          type="warning"
          v-model="alert"
          close-label="Close Alert"
          dismissible
        >
          <span
            >شما حق اشتراک فعالی ندارید که بتوانید از آن استفاده کنید.
          </span>
          <span>
            هزینه انتشار : {{ totalPrice.amount | priceSplitter }} ریال</span
          >
          <v-dialog v-model="priceDetailsDialog" width="500">
            <template v-slot:activator="{ on, attrs }">
              <v-btn v-bind="attrs" v-on="on"> مشاهده جزئیات هزینه </v-btn>
            </template>

            <v-card>
              <v-card-title class="text-h5 grey lighten-2">
                جزئیات هزینه
              </v-card-title>

              <v-card-text>
                <table
                  class="m-2 table table-bordered table-head-bg table-primary text-center"
                >
                  <thead>
                    <tr>
                      <th class="bg-gray-300"></th>
                      <th>قیمت واحد</th>
                      <th>تعداد</th>
                      <th>جمع</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr>
                      <th>قیمت سرویس</th>
                      <td>
                        {{
                          this.membershipAndPrice.servicePriceDetails
                            .servicePrice.price | priceSplitter
                        }}
                      </td>
                      <td>
                        {{
                          this.membershipAndPrice.servicePriceDetails
                            .servicePrice.itemsCount | priceSplitter
                        }}
                      </td>
                      <td>
                        {{
                          this.membershipAndPrice.servicePriceDetails
                            .servicePrice.totalPrice | priceSplitter
                        }}
                      </td>
                    </tr>
                    <tr>
                      <th>نیاز به کمک فنی</th>
                      <td>
                        {{
                          this.membershipAndPrice.servicePriceDetails
                            .technicalHelpNeededPrice.price | priceSplitter
                        }}
                      </td>
                      <td>
                        {{
                          this.membershipAndPrice.servicePriceDetails
                            .technicalHelpNeededPrice.itemsCount | priceSplitter
                        }}
                      </td>
                      <td>
                        {{
                          this.membershipAndPrice.servicePriceDetails
                            .technicalHelpNeededPrice.totalPrice | priceSplitter
                        }}
                      </td>
                    </tr>
                    <tr class="bg-primary-o-50">
                      <th colspan="3">جمع کل</th>
                      <td>
                        {{
                          this.membershipAndPrice.servicePriceDetails.totalPrice
                            | priceSplitter
                        }}
                      </td>
                    </tr>
                  </tbody>
                </table>
              </v-card-text>

              <v-divider></v-divider>

              <v-card-actions>
                <v-spacer></v-spacer>
                <v-btn color="primary" text @click="priceDetailsDialog = false">
                  بستن
                </v-btn>
              </v-card-actions>
            </v-card>
          </v-dialog>
        </v-alert>

        <v-alert
        v-if="succeed!==undefined"
          :type="succeed ? 'success' : 'error'"
          close-label="بستن هشدار"
          dismissible
        >
          {{
            succeed
              ? 'پرداخت شما با موفقیت انجام شد'
              : 'پرداخت با موفقیت انجام نشد'
          }}
        </v-alert>
        <payment-step
          :getMembershipAndPrice="true"
          @getHasPayment="closePaymentStep()"
          :totalPrice="totalPrice"
          :objectId="reportData.id"
          :sourceType="membershipAndPrice.servicePriceDetails.paymentSourceType"
        ></payment-step>
      </div>

      <div v-else class="mt-3">
        <v-alert
          type="success"
          v-model="alert"
          close-label="Close Alert"
          dismissible
        >
          .شما دارای اشتراک فعال جهت استفاده از این خدمت هستید
        </v-alert>
      </div>
    </div>
    <v-card-actions>
      <v-spacer />
      <!-- <v-btn color="primary" @click="editItem()">ویرایش</v-btn> -->

      <v-btn
        color="success"
        @click="confirmRequest()"
        :disabled="
          !(
            membershipAndPrice &&
            membershipAndPrice.hasMembership &&
            membershipAndPrice.membershipDetails &&
            membershipAndPrice.membershipDetails.isAvailable
          )
        "
        >ارسال جهت انتشار</v-btn
      >
      <v-btn
        color="success"
        @click="goToNextStep()"
        v-if="succeed || succeedPayment"
        >ادامه</v-btn
      >

      <v-btn color="error" @click="$router.push('/trade-request')">بستن</v-btn>
    </v-card-actions>
  </div>
</template>

<script>
import asyncLoadMixin from '@/core/mixins/asyncLoadMixin';
import reusableMethodsMixin from '@/core/mixins/reusableMethodsMixin';
import Helper from '@/core/helpers';
import TradeRequestInformationTable from './TradeRequestInformationTable';
const tradeRequestRepository = () => RepoFactory.get('tradeRequests');
const tradeRequestsRepository = () => RepoFactory.get('tradeRequests');
const pagesRepository = () => RepoFactory.get('pages');
const merchantRepository = () => RepoFactory.get('merchant');
import { RepoFactory } from '@/baseRepository/Factory';
import qs from 'qs';
import PaymentStep from '../../FinancialManagement/subscription/components/PaymentStep.vue';
export default {
  mixins: [asyncLoadMixin, reusableMethodsMixin],
  components: {
    TradeRequestInformationTable,
    PaymentStep,
  },
  created() {
    this.loadPage();
  },
  data() {
    return {
      priceDetailsDialog: false,
      reportData: {},
      alert: true,
      title: '',
      body: '',
      stateIds: [],
      stateName: [],
      cityName: [],
      tradeGuaranteeList: [],
      tradeRequestTypeList: [],
      tradeCategoriesList: [],
      tradePaymentMethodList: [],
      deliveryDurationTypeList: [],
      responseDocumentHeader: [
        {
          value: 'isOptional',
          text: 'اختیار الصاق',
          sortable: true,
        },
        {
          value: 'documentTypeTitle',
          text: 'عنوان اصلی ',
          sortable: true,
        },
        {
          value: 'subTitle',
          text: 'عنوان دلخواه',
          sortable: true,
        },
      ],
      tradeRequestInformationFields: [
        {
          value: 'productCategoryName',
          text: 'نام فعالیت',
          sortable: false,
        },
        {
          value: 'processType',
          text: 'نوع فرآیند',
          sortable: false,
        },
        {
          value: 'breadcrumb.breadcrumb',
          text: 'فرایند اصلی',
          sortable: false,
        },
      ],
      deliveryItemHeader: [
        {
          text: 'تعداد',
          value: 'amount',
        },
        {
          text: 'تاریخ',
          value: 'deliveryDateUtc',
        },
      ],
      membershipAndPrice: null,
      succeedPayment: false,
    };
  },
  computed: {
    totalPrice() {
      //if (!this.membershipAndPrice.hasMembership) {
        return {
          amount: this.membershipAndPrice.servicePriceDetails.totalPrice,
          currency: 'IRR',
        };
      //} else return null;
    },
    tradeBaseUrl() {
      return this.$store.getters.tradeBaseUrl;
    },
    contentBaseUrl() {
      return this.$store.getters.contentBaseUrl;
    },
    currentRoute() {
      return this.$route.fullPath;
    },
    merchantId() {
      return this.$store.getters.currentMerchant;
    },
    succeed() {
      if (this.$route.query.succeed === undefined) return undefined;
      return this.$route.query.succeed == 'True' ? true : false;
    },
  },
  methods: {
    loadPage() {
      this.getData(this.$route.params.id);
    },
    getData(id) {
      const loader = this.$loading.show();
      tradeRequestsRepository()
        .getTradeRequestById(id, this.tradeBaseUrl)
        .then((res) => {
          this.reportData = res.data;
          this.getPageData();
          this.tradeCategories();
          this.tradeRequestType();
          this.tradePaymentMethod();
          this.getTradeLimitation();
          this.rawMaterialSupplyTypes();
          this.deliveryLocationItems();
          this.materialSupplyType();
          this.DeliveryDurationType();
          this.tradeGuaranteeMethod();
          this.getTradeRequestMembershipAndPrice();
        })
        .catch((err) => {
          Helper.handleErrors(err, this);
        })
        .finally(() => loader.hide());
    },
    closePaymentStep() {
      this.succeedPayment = true;
    },
    getTradeRequestMembershipAndPrice() {
      const loader = this.$loading.show();
      tradeRequestRepository()
        .getTradeRequestMembershipAndPrice(
          this.reportData.id,
          this.tradeBaseUrl,
          {
            MerchantId: this.merchantId,
          }
        )
        .then((res) => {
          this.membershipAndPrice = res.data;
        })
        .catch((err) => {
          Helper.handleErrors(err, this);
        })
        .finally(() => {
          loader.hide();
        });
    },
    getPageData() {
      let params = {
        uniquePageName: this.$store.getters.uniqPageSendOrderToAdmin,
      };
      const loader = this.$loading.show();
      pagesRepository()
        .getUniquePage(this.contentBaseUrl, {}, params)
        .then(({ data }) => {
          this.title = data.title;
          this.body = data.body;
          loader.hide();
        })
        .catch((err) => {
          Helper.handleErrors(err, this);
          loader.hide();
        });
    },
    tradeCategoryDisplayName(title) {
      if (this.tradeCategoriesList.length) {
        let result = this.tradeCategoriesList.find((el) => el.title == title);
        if (result) return result.displayName;
      }
    },
    tradeRequestDisplayName(title) {
      if (this.tradeRequestTypeList.length) {
        let result = this.tradeRequestTypeList.find((el) => el.title == title);
        if (result) return result.displayName;
      }
    },
    paymentMethodDisplayName(title) {
      if (this.tradePaymentMethodList.length) {
        let result = this.tradePaymentMethodList.find(
          (el) => el.title == title
        );
        if (result) return result.displayName;
      }
    },
    DeliveryDurationDisplayName(title) {
      if (this.deliveryDurationTypeList.length) {
        let result = this.deliveryDurationTypeList.find(
          (el) => el.title == title
        );
        if (result) return result.displayName;
      }
    },
    materialSupplyTypeDisplayName(title) {
      if (this.rawMaterialSupplyTypesList.length) {
        let result = this.rawMaterialSupplyTypesList.find(
          (el) => el.title == title
        );
        if (result) return result.displayName;
      }
    },
    DeliveryLocationDisplayName(title) {
      if (this.deliveryLocationList.length) {
        let result = this.deliveryLocationList.find((el) => el.title == title);
        if (result) return result.displayName;
      }
    },
    guaranteeMethodDisplayName(title) {
      if (this.tradeGuaranteeList.length) {
        let result = this.tradeGuaranteeList.find((el) => el.title == title);
        if (result) return result.displayName;
      }
    },
    tradeGuaranteeMethod() {
      this.tradeGuaranteeList = this.getEnumByTitle('GuaranteeType');
    },
    tradeCategories() {
      this.tradeCategoriesList = this.getEnumByTitle('CategoryTypeItems');
    },
    tradeRequestType() {
      this.tradeRequestTypeList = this.getEnumByTitle('TradeRequestType');
    },
    tradePaymentMethod() {
      this.tradePaymentMethodList = this.getEnumByTitle(
        'TradePaymentMethodType'
      );
    },
    DeliveryDurationType() {
      this.deliveryDurationTypeList = this.getEnumByTitle(
        'DeliveryDurationType'
      );
    },
    materialSupplyType() {
      this.materialSupplyTypeList = this.getEnumByTitle('materialSupplyType');
    },
    deliveryLocationType() {
      this.deliveryLocationList = this.getEnumByTitle('DeliveryLocationType');
    },
    rawMaterialSupplyTypes() {
      this.rawMaterialSupplyTypesList = this.getEnumByTitle(
        'RawMaterialSupplyType'
      );
    },
    deliveryLocationItems() {
      this.deliveryLocationList = this.getEnumByTitle('DeliveryLocationType');
    },
    getTradeLimitation() {
      if (this.reportData.limitation == 'State') {
        this.limitation = 'State';
        this.limit = true;
        this.getStates();
        this.reportData.limitationsDtos.forEach((x) => {
          this.stateIds.push(x.id);
          this.stateName.push(x.value);
        });
      } else if (this.reportData.limitation == 'City') {
        this.limitation = 'City';
        this.limitationIds = [];

        this.limit = true;
        this.getStates();
        this.reportData.limitationsDtos.forEach((x) => {
          this.limitationIds.push(x.id);
          this.cityName.push(x.value);
          this.stateIds.push(x.stateId);
          this.stateName.push(x.stateName);
        });
        this.cityName = Array.from(new Set(this.cityName));
        this.limitationIds = Array.from(new Set(this.limitationIds));
        this.stateIds = Array.from(new Set(this.stateIds));
        this.stateName = Array.from(new Set(this.stateName));
      }
    },
    getStates() {
      merchantRepository()
        .getProvince(this.merchantBaseUrl)
        .then((res) => {
          this.statesList = res.data;
        })
        .catch((error) => {
          Helper.handleErrors(error, this);
        });
    },
    getCitiesByStateIds() {
      let params = {
        stateIds: this.stateIds,
      };
      merchantRepository()
        .getCitiesOfMultipleStatesTree(
          this.merchantBaseUrl,
          params,
          {},
          (params) => {
            return qs.stringify(params, { arrayFormat: 'repeat' });
          }
        )
        .then((res) => {
          this.citiesList = res.data;
        });
    },
    editItem() {
      if (!this.$route.fullPath.includes('edit')) {
        this.$store.commit('setTradeRequestSelectedItem', this.reportData);
        this.$store.commit('setTradeRequestIsEdit', true);
        this.$router.push({
          path: `/trade-request-edit/${this.reportData.id}`,
        });
      } else {
        // this.$emit('reportFlag');
      }
    },
    confirmRequest() {
      let app = this;
      const loader = this.$loading.show();
      tradeRequestRepository()
        .sendConfirmRequest(this.reportData.id, this.tradeBaseUrl)
        .then((res) => {
          app.$dialog.info({
            text: this.body,
            title: this.title,
            persistent: true,
            actions: [
              {
                text: 'بستن',
                color: 'red',
              },
            ],
          });
          this.goToNextStep();
        })
        .catch((err) => {
          Helper.handleErrors(err, this);
        })
        .finally(() => {
          loader.hide();
        });
    },
    goToNextStep() {
      if (this.currentRoute != '/trade-request') {
        this.clearStore();
        this.$router.push({ path: '/trade-request' });
      } else {
        // this.$emit('reportFlag');
        this.getData();
      }
    },
    clearStore() {
      this.$store.commit('setTradeRequestFormStatus', false);
      this.$store.commit('setTradeRequestIsEdit', false);
      this.$store.commit('setTradeRequestSelectedForEdit', null);
      this.$store.commit('setTradeRequestShowDetailForm', false);
      this.$store.commit('setTradeRequestSingleItem', null);
      this.$store.commit('setTradeRequestSingleItemForEdit', null);
      this.$store.commit('setTradeRequestItems', []);
      this.$store.commit('setTradeRequestSelectedForDisplay', null);
      this.$store.commit('setTradeRequestCategoryType', null);
      this.$store.commit('setTradeRequestEditMode', false);
      this.$store.commit('setTradeRequestResponsesPerItem', null);
      this.$store.commit('setTradeRequestNumber', null);
      this.$store.commit('setTradeRequestDate', null);
      this.$store.commit('setTradeRequestResponsesHeader', null);
      this.$store.commit('setTradeRequestSelectedForResponse', null);
    },
  },
};
</script>

<style></style>
